import React from "react";

const FormTextArea = ({id, label, classes, name, handleChange}) => {

  return (
    <div className="form-group mb-4">
      <label className="font-weight-bold lead" htmlFor={id}>{label}</label><br />
      <textarea id={id} className={classes} name={name} onChange={(item) => handleChange(item)} />
    </div>
  );
}

export default FormTextArea;